import React, { useRef, useState } from "react"
import styled from "styled-components"
import EmailEditor from "react-email-editor" // use react-email-editor instead
import { useParams } from 'react-router-dom';
import axios from "axios"  
import { useSelector  } from "react-redux";
import { selectLogInUsername } from "../../../../../common/authenticateDashboard/authSlice"
import { getDatabase, ref, get, set, update } from 'firebase/database';
import { nudges, nudgesCompany } from '../../../../../firebase';
import { nanoid } from 'nanoid'; // Import nanoid



const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
`

const Bar = styled.div`
  flex: 1;
  background-color: #172b4d;
  color: #000;
  padding: 15px;
  display: flex;
  justify-content: center;
  max-height: 50px;
  align-items: center;

  h1 {
    flex: 1;
    font-size: 18px;
    text-align: left;
  }

  button {
    padding: 10px 15px;
    margin-left: 10px;
    font-size: 14px;
    font-weight: bold;
    background-color: #000;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #333;
    }

    &:active {
      background-color: #555;
    }
  }
`;

const PredefinednudgesEditor = () => {

  const emailEditorRef = useRef(null)
  const [preview, setPreview] = useState(false)
  const [designName, setDesignName] = useState("")  
  const { endpoint1, endpoint2 } = useParams();
  const sessionUser = useSelector(selectLogInUsername)
  const user = sessionUser?.split('@')[0];


  const saveAndExportDesign = async () => {
    const unlayer = emailEditorRef.current?.editor;
  
    try {
      // Save design and export HTML concurrently using Promise.all
      const [design, { html }] = await Promise.all([
        new Promise((resolve, reject) => {
          unlayer?.saveDesign(design => {
            console.log("saveDesign", design);
            resolve(design);
          });
        }),
        new Promise((resolve, reject) => {
          unlayer?.exportHtml(data => {
            const { design, html } = data;
            console.log("exportHtml", html);
            resolve({ design, html });
          });
        })
      ]);
  

      const db = getDatabase(nudgesCompany);
      const userRef = ref(db, user);
      console.log("user--->", user);
      console.log("User ref", userRef);
      
      const userSnapshot = await get(userRef);
      if (!userSnapshot.exists()) {
          await set(userRef, {});
          console.log("Created");
      }
      console.log("user found")
      const uniqueId = nanoid();
      
      const newData = { [designName]: { design, html, name: designName, uniqueId } };

      
      // Function to recursively replace undefined values with null
      function replaceUndefinedWithNull(obj) {
          for (const key in obj) {
              if (typeof obj[key] === 'object' && obj[key] !== null) {
                  replaceUndefinedWithNull(obj[key]);
              } else if (obj[key] === undefined) {
                  obj[key] = null;
              }
          }
      }
      
      // Replace undefined values with null in newData
      replaceUndefinedWithNull(newData);
      
      console.log("newData-->", newData);
      
      await update(userRef, newData);
      
      console.log("Design", design);
      console.log("Data saved successfully");
      alert("Data saved successfully.");
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while processing the data.");
    }
  };  

  const togglePreview = () => {
    const unlayer = emailEditorRef.current?.editor

    if (preview) {
      unlayer?.hidePreview()
      setPreview(false)
    } else {
      unlayer?.showPreview("desktop")
      setPreview(true)
    }
  }

  const onDesignLoad = data => {
    console.log("onDesignLoad", data)
  }

 

  const onLoad = async (unlayer) => {
    console.log("onLoad", unlayer);
    
    // Register event listener for design loaded event
    unlayer.addEventListener("design:loaded", onDesignLoad);
  
    try {
      const db = getDatabase(nudges); // Get a reference to the database
      const companyProdsRef = ref(db, 'CompanyProds'); // Reference to the "CompanyProds" node
      const snapshot = await get(companyProdsRef); // Fetch data from the database
  
      console.log("snapshot", snapshot);
      if (snapshot.exists()) {
        const data = snapshot.val(); // Retrieve the data from the snapshot
        console.log("data endpoint-->", data);
  
        // Traverse through the nested object to find the design corresponding to the endpoint ID
        const findDesign = (obj, endpointId) => {
          for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
              const item = obj[key];
              
              // Check if this item has a uniqueId and if it matches the endpointId
              if (item.uniqueId === endpointId) {
                return item.design; // If uniqueId matches, return the design
              }
  
              // If the item is an object, recursively search within it
              if (typeof item === 'object' && item !== null) {
                const design = findDesign(item, endpointId);
                if (design) return design; // If design found, return it
              }
            }
          }
          return null; // Return null if design not found
        };
  
        const design = findDesign(data, endpoint2); // Call the function to find the design
        console.log("design", design);
        if (design) {
          unlayer.loadDesign(design); // Load the design into Unlayer
        } else {
          console.log('Design not found');
        }
      } else {
        console.log('No data available');
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
  };
  
  

  const onReady = unlayer => {
    console.log("onReady", unlayer)
  }

  return (
    <Container className="w-full h-auto">
    <Bar>

      {/* <input
        type="text"
        placeholder="Enter Design Name"
        value={designName}
        onChange={e => setDesignName(e.target.value)}
        style={{ marginRight: "10px" }}
      /> */}


      <div class="relative w-[80vh]">
        <input
          type="text"
          placeholder="Enter Design Name"
          value={designName}
          onChange={e => setDesignName(e.target.value)} class="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" Placeholder="Enter the Design name" required />
        <button onClick={saveAndExportDesign} class=" text-white absolute end-2.5 bottom-1.5 text-sm px-4 py-1 bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg">Save Design</button>
      </div>


      <button onClick={togglePreview} class=" text-white text-sm px-4 py-1 bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg">
        {preview ? "Hide" : "Show"} Preview
      </button>
      {/* <button onClick={saveAndExportDesign} class="m-2 text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2" >Save Design</button> */}
    </Bar>

      <React.StrictMode>
        <EmailEditor ref={emailEditorRef} onLoad={onLoad} onReady={onReady}  displayMode="email"/>
      </React.StrictMode>
    </Container>
  )
}

export default PredefinednudgesEditor